import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18nify';
import EditModal from '../modal/EditModal';
import EditSharedThreatPolicy from '../../containers/shared_policies/EditSharedThreatPolicy';

const EditSharedThreatPolicyModal = ({
  showModal,
  closeDialog,
  buttonAction,
  disabled,
}) => (
  <EditModal
    title={translate('components.mspSharedAtp.sharedThreatPolicy')}
    showModal={showModal}
    buttonAction={buttonAction}
    closeDialog={closeDialog}
    saveBtnText={translate('shared.save')}
    disabled={disabled}
  >
    <EditSharedThreatPolicy />
  </EditModal>
);

EditSharedThreatPolicyModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  closeDialog: PropTypes.func.isRequired,
  buttonAction: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  hideNetwork: PropTypes.bool,
};

EditSharedThreatPolicyModal.defaultProps = {
  disabled: false,
};

export default EditSharedThreatPolicyModal;
